<template>
  <div
    :class="
      'position-fixed modal d-flex flex-column justify-content-center container-fluid ' +
        (swag ? swag : '')
    "
  >
    <slot> </slot>
  </div>
</template>

<script>
export default {
  props: ["swag"],
}
</script>

<style lang="scss"></style>
